export const SEND_SUPPORT_EMAIL_REQUEST = "send_support_email_request";
export const SEND_SUPPORT_EMAIL_SUCCESSFUL = "send_support_email_successful";
export const SEND_SUPPORT_EMAIL_FAILED = "send_support_email_failed";

export const CLEAR_ALL_SUPPORT_MESSAGES = "clear_all_support_messages";
export const CLEAR_ALL_SUPPORT_MESSAGES_SUCCESSFUL = "clear_all_support_messages_successful";